<template>
  <v-container class="pa-0 ma-0 academics-page">
    <h1 class="show-title mb-10">{{ content.title }}</h1>
    <v-img
      src="@/assets/images/academics/challenges/challenges.png"
      contain
      class="mb-10"
    ></v-img>
    <div v-html="content.page" class="academics-text"></div>
  </v-container>
</template>

<script>
export default {
  name: 'challenges',
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
}
</script>
